var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Renderer } from "@angular/core";
import { Puzzle2048Service } from "./services/puzzle-2048.service";
import { GameService } from "./services/game-manager.service";
import { PuzzleKeyboardService } from "./services/puzzle-keyboard.service";
export var Puzzle2048Component = (function () {
    function Puzzle2048Component(game, renderer) {
        this.game = game;
        this.renderer = renderer;
    }
    Puzzle2048Component.prototype.newGame = function () {
        this.game.newGame();
    };
    Puzzle2048Component.prototype.ngOnInit = function () {
        var self = this;
        this.newGame();
        this.globalListenFunc = this.renderer.listenGlobal('document', 'keydown', function (event) {
            var key = PuzzleKeyboardService.getEventKeyCode(event.keyCode);
            if (key) {
                event.preventDefault();
                self.game.move(key);
            }
        });
    };
    Puzzle2048Component.prototype.doSwipe = function (direction) {
        var self = this;
        var key = PuzzleKeyboardService.getEventSwipeCode(direction);
        if (key) {
            self.game.move(key);
        }
    };
    Puzzle2048Component.prototype.ngOnDestroy = function () {
        event.preventDefault();
        this.globalListenFunc();
    };
    Puzzle2048Component.prototype.onChangeSize = function (e) {
        if (e.value < this.game.gameSize) {
            this.game.decSize();
        }
        else {
            this.game.incSize();
        }
    };
    Puzzle2048Component = __decorate([
        Component({
            moduleId: module.id,
            selector: 'my-puzzle-2048',
            templateUrl: 'puzzle-2048.component.html',
            styleUrls: ['puzzle-2048.component.css'],
            providers: [Puzzle2048Service, GameService, PuzzleKeyboardService]
        }), 
        __metadata('design:paramtypes', [GameService, Renderer])
    ], Puzzle2048Component);
    return Puzzle2048Component;
}());
//# sourceMappingURL=puzzle-2048.component.js.map